import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { composeRichTextComponents, Text, InlineHyperLink, CMSContent } from '@cbhq/cdx-components';
import { GLOBAL_NAV_LINK_CONTENT_MODEL_ID } from '../../globals/navlink.js';
import { isContentEntryOfType } from '../../utils/isContentEntryOfType.js';
import { jsx } from 'react/jsx-runtime';
const cellOptions = composeRichTextComponents({
  customRenderOptions: {
    [BLOCKS.PARAGRAPH]: props => function Paragraph(node, children) {
      /**
       * Embedded content are rendered inside Paragraph blocks, and we can't render sections/divs inside <p> tags,
       * so if the embedded content is a Content Model and not GlobalNavLink, it should render as div.
       * Embedded elements have props but no children prop, italic and bold elements have only children prop.
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      const shouldRenderAsDiv = children.some(c => c.props && !c.props?.children && !isContentEntryOfType(GLOBAL_NAV_LINK_CONTENT_MODEL_ID, c.props.content));

      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      if (!children.some(child => !!child)) return null;
      return /*#__PURE__*/jsx(Text, {
        as: shouldRenderAsDiv ? 'div' : 'p',
        display: "block",
        variant: "body",
        spacingTop: props?.paragraphSpacingTop,
        color: props?.secondaryColor,
        css: {
          wordBreak: 'normal',
          overflowWrap: 'anywhere'
        },
        children: children
      });
    },
    [INLINES.HYPERLINK]: () => InlineHyperLink({
      dataQa: 'RichtextTableLink'
    }),
    [INLINES.EMBEDDED_ENTRY]: () => function EmbeddedEntry(node) {
      if (!node?.data?.target) return null;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      return /*#__PURE__*/jsx(CMSContent, {
        content: node?.data?.target
      });
    }
  }
});
export { cellOptions };
//# sourceMappingURL=cellOptions.js.map
